export const buildFullPhoneNumber = (
  countryCode: string | null,
  phoneNumber: string | null
) => {
  if (phoneNumber === "" || phoneNumber === null) return null;
  const fallbackCountryCode =
    countryCode === "" || countryCode === null ? "1" : countryCode;
  return `${fallbackCountryCode}${phoneNumber}`;
};
